import { render, staticRenderFns } from "./CatalogoSoluciones.vue?vue&type=template&id=8f99c756&"
import script from "./CatalogoSoluciones.vue?vue&type=script&lang=js&"
export * from "./CatalogoSoluciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports